import { ISlot } from "@gettactic/api";
import { UserOnMeetingTile } from "../UserOnMeetingTile/UserOnMeetingTile";
import { MeetingUserGrid } from "../MeetingUserGrid/MeetingUserGrid";

export type ExtendedInvitation = ISlot & {
  photo_url: string;
};

export type DashboardEventAttendeesProps = {
  slots: ISlot[];
};

/** Who is invited to a meeting, with their answers, in a grid. */
export const DashboardEventAttendees = ({
  slots
}: DashboardEventAttendeesProps) => {
  return (
    <MeetingUserGrid classNames="pt-6">
      {slots.map((slot) => (
        <UserOnMeetingTile slot={slot} key={slot.id} />
      ))}
    </MeetingUserGrid>
  );
};
